(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder-custom"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bb-root]').forEach(initBundle);

    function initBundle(root) {
      const parentVariantId = root.dataset.parentVariantId;
      const strategy = root.dataset.strategy;
      const moneyFormat = root.dataset.moneyFormat || ('$' + String.fromCharCode(123, 123) + 'amount' + String.fromCharCode(125, 125));
      const tiers = parseTiers(root.dataset.tiers);
      const items = root.querySelectorAll('[data-item]');
      const subtotalEl = root.querySelector('[data-bb-subtotal]');
      const saveEl = root.querySelector('[data-bb-save]');
      const saveRow = root.querySelector('[data-bb-save-row]');
      const totalEl = root.querySelector('[data-bb-total]');
      const tiersEl = root.querySelector('[data-bb-tiers]');
      const hintEl = root.querySelector('[data-bb-hint]');
      const submitBtn = root.querySelector('[data-bb-submit]');
      const errorEl = root.querySelector('[data-bb-error]');
      const steps = root.querySelectorAll('[data-required]');

      renderTiers(0);

      items.forEach(function (item) {
        const check = item.querySelector('[data-bb-check]');
        const qtyWrap = item.querySelector('[data-bb-qty-wrap]');
        const qtyInput = item.querySelector('[data-bb-qty]');
        const inc = item.querySelector('[data-bb-qty-inc]');
        const dec = item.querySelector('[data-bb-qty-dec]');

        item.addEventListener('click', function (e) {
          if (e.target.closest('[data-bb-qty-wrap]')) e.preventDefault();
        });

        check.addEventListener('change', function () {
          qtyWrap.hidden = !check.checked;
          if (!check.checked) qtyInput.value = 1;
          update();
        });

        inc.addEventListener('click', function () {
          const max = parseInt(qtyInput.max, 10) || 99;
          qtyInput.value = Math.min(max, (parseInt(qtyInput.value, 10) || 1) + 1);
          update();
        });
        dec.addEventListener('click', function () {
          qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
          update();
        });
        qtyInput.addEventListener('input', update);
      });

      submitBtn.addEventListener('click', addToCart);
      update();

      function getSelected() {
        const selected = [];
        items.forEach(function (item) {
          const check = item.querySelector('[data-bb-check]');
          if (!check.checked) return;
          const qtyInput = item.querySelector('[data-bb-qty]');
          const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
          const baseQty = parseInt(item.dataset.baseQty, 10) || 1;
          selected.push({
            variantId: item.dataset.variantId,
            quantity: qty * baseQty,
            price: parseInt(item.dataset.price, 10) || 0,
            userQty: qty,
          });
        });
        return selected;
      }

      function update() {
        const selected = getSelected();
        const totalCount = selected.reduce(function (s, i) { return s + i.quantity; }, 0);
        const subtotalCents = selected.reduce(function (s, i) { return s + i.price * i.quantity; }, 0);

        const active = pickTier(tiers, totalCount);
        const discountCents = active ? Math.round(subtotalCents * (active.percent / 100)) : 0;
        const totalCents = subtotalCents - discountCents;

        subtotalEl.textContent = formatMoney(subtotalCents, moneyFormat);
        totalEl.textContent = formatMoney(totalCents, moneyFormat);
        saveEl.textContent = '-' + formatMoney(discountCents, moneyFormat);
        saveRow.hidden = discountCents === 0;

        renderTiers(totalCount);
        renderHint(totalCount);

        const stepsOk = Array.from(steps).every(function (s) {
          const req = parseInt(s.dataset.required, 10) || 1;
          const stepSelected = s.querySelectorAll('[data-bb-check]:checked').length;
          return stepSelected >= req;
        });
        submitBtn.disabled = !stepsOk || selected.length === 0;
      }

      function renderTiers(totalCount) {
        if (!tiers.length) { tiersEl.innerHTML = ''; return; }
        const active = pickTier(tiers, totalCount);
        tiersEl.innerHTML = tiers.map(function (t) {
          const isActive = active && active.min_qty === t.min_qty;
          return '<div class="bb-custom__tier' + (isActive ? ' bb-custom__tier--active' : '') + '">'
            + '<span class="bb-custom__tier-pct">' + t.percent + '%</span>'
            + '<span class="bb-custom__tier-req">' + t.min_qty + '+</span>'
            + '</div>';
        }).join('');
      }

      function renderHint(totalCount) {
        if (!tiers.length) { hintEl.hidden = true; return; }
        const next = tiers.find(function (t) { return totalCount < t.min_qty; });
        if (!next) { hintEl.hidden = true; return; }
        const missing = next.min_qty - totalCount;
        hintEl.hidden = false;
        hintEl.textContent = 'Agrega ' + missing + ' producto' + (missing === 1 ? '' : 's')
          + ' más para desbloquear ' + next.percent + '% de descuento.';
      }

      async function addToCart() {
        errorEl.hidden = true;
        const selected = getSelected();
        if (selected.length === 0) return;
        const instanceId = String(Date.now());
        const lines = strategy === 'fixed_components'
          ? [{
              id: parentVariantId,
              quantity: 1,
              properties: {
                '_bundle_parent_id': parentVariantId,
                '_bundle_instance_id': instanceId,
                '_bundle_items': JSON.stringify(selected.map(function (s) {
                  return { variant_id: s.variantId, quantity: s.quantity };
                }))
              }
            }]
          : selected.map(function (s) {
              return {
                id: s.variantId,
                quantity: s.quantity,
                properties: {
                  '_bundle_parent_id': parentVariantId,
                  '_bundle_instance_id': instanceId,
                }
              };
            });

        submitBtn.disabled = true;
        submitBtn.textContent = 'Añadiendo…';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: lines }),
          });
          if (!res.ok) {
            const body = await res.json().catch(function () { return {}; });
            throw new Error(body.description || 'No se pudo añadir el bundle.');
          }
          window.location.href = '/cart';
        } catch (err) {
          errorEl.hidden = false;
          errorEl.textContent = err.message || 'Error al añadir al carrito.';
          submitBtn.disabled = false;
          submitBtn.textContent = 'Añadir al carrito';
        }
      }
    }

    function parseTiers(raw) {
      if (!raw) return [];
      try {
        const arr = JSON.parse(raw);
        if (!Array.isArray(arr)) return [];
        return arr
          .map(function (t) {
            return { min_qty: parseInt(t.min_qty, 10), percent: parseFloat(t.percent) };
          })
          .filter(function (t) { return Number.isFinite(t.min_qty) && Number.isFinite(t.percent); })
          .sort(function (a, b) { return a.min_qty - b.min_qty; });
      } catch (_e) { return []; }
    }

    function pickTier(tiers, count) {
      let active = null;
      for (const t of tiers) if (count >= t.min_qty) active = t;
      return active;
    }

    function formatMoney(cents, format) {
      const amount = (cents / 100).toFixed(2);
      const parts = amount.split('.');
      const int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const withDec = int + '.' + parts[1];
      const OPEN = '{' + '{';
      const CLOSE = '}' + '}';
      const rx = new RegExp(OPEN + '\\s*amount(_no_decimals)?\\s*' + CLOSE, 'g');
      const fallback = '$' + OPEN + 'amount' + CLOSE;
      return (format || fallback).replace(rx, function (_m, nd) {
        return nd ? int : withDec;
      });
    }

    if (new URLSearchParams(location.search).get('bb_debug') === '1') {
      const OPEN = '{' + '{', CLOSE = '}' + '}';
      console.assert(formatMoney(34900, '$' + OPEN + 'amount' + CLOSE) === '$349.00', 'formatMoney basic');
      console.assert(formatMoney(100000, '$' + OPEN + 'amount_no_decimals' + CLOSE) === '$1,000', 'formatMoney no dec');
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
